<template>
  <channel-dashboard
    :channels="channels"
    :activeChannelTab="activeChannelTab"
    @onChangeTab="onChangeTab($event)">
  </channel-dashboard>
</template>

<script>
import { mapGetters } from 'vuex';

import ChannelDashboard from '@/components/channel/ChannelDashboard';

export default {
  name: 'ChannelContainer',
  data: () => ({
    activeChannelTab: 'activeChannels',
  }),
  components: {
    ChannelDashboard,
  },
  computed: {
    ...mapGetters('channel', ['activeChannels', 'inactiveChannels', 'channelIcons']),
    channels() {
      return (this.activeChannelTab === 'activeChannels' ? this.activeChannels : this.inactiveChannels);
    },
  },
  mounted() {
    this.$store.dispatch('channel/getChannels');
  },
  methods: {
    onChangeTab(event) {
      this.activeChannelTab = event.activeChannelTab.activeChannelTab;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ChannelContainer.vue?3202269c